import React, { useEffect, useState } from "react";
import heartLoading from "../../assests/heartLoading.gif";
import Tooltip from "@mui/material/Tooltip";
import { ChevronLeft, ChevronRight } from "@mui/icons-material";
import { Search } from "lucide-react";
import Skeleton from "@mui/material/Skeleton";
import TableBody from "./TableBody";
import TableHead from "./TableHead";

const BASE_URL = process.env.REACT_APP_API_URL
const Table = ({ tableData = [], pagination = {}, onSearchChange,
onColumnFiltersChange, 
 onPageChange , errorPreviews = {} ,loading = false}) => {

   const [selectedPreview, setSelectedPreview] = useState("");
   const [isDownloading, setIsDownloading] = useState(false);
   const [columnSearch, setColumnSearch] = React.useState({
    ruleId: "",
  ruleName: "",
  rulePhase: "",
  dqDimension: "",
  dataAssetName: "",
  failPercentageVsThreshold: "",
  breachDate: "",
  Status: "",
  ruleOwner: "",
  Ticket: "",
  allsearch: "",     
});
const tableContainerRef = React.useRef(null);
const previewTableRef = React.useRef(null);


   const [isSearching,setIsSearching]=React.useState(false)

  const currentPage = pagination?.currentPage ?? 1;
  const pageSize = pagination?.pageSize ?? 10;
  const totalRecords = pagination?.totalRecords ?? (tableData?.length ?? 0);

  const totalPages =
    pagination?.totalPages ?? Math.max(1, Math.ceil(totalRecords / pageSize));

  const indexOfFirstRow = (currentPage - 1) * pageSize + 1;
  const indexOfLastRow = Math.min(currentPage * pageSize, totalRecords);

  const gotoPage = (page) => {
    if (page < 1 || page > totalPages) return;
    onPageChange && onPageChange(page);
  };

   const downloadExcel = (datasetKey) => {
    if (!datasetKey) return;
    setIsDownloading(true);

    const url = `${BASE_URL}/download-url/${encodeURIComponent(datasetKey)}`;

    fetch(url)
      .then((res) => {
        const cd = res.headers.get("content-disposition");
       let filename = datasetKey + ".csv";       
        if (cd) {
          const match = cd.match(/filename="?([^"]+)"?/);
          if (match) filename = match[1];
        }
        return res.blob().then((blob) => ({ blob, filename }));
      })
      .then(({ blob, filename }) => {
        const urlObj = window.URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = urlObj;
        link.download = filename;
        link.click();
        window.URL.revokeObjectURL(urlObj);
      })
      .catch((err) => console.error("Download failed:", err))
       .finally(() => {
      setIsDownloading(false);   
    });
      
  };
  

useEffect(() => {
  setIsSearching(loading);
}, [loading]);
useEffect(() => {
  if (tableData.length > 0) {
    setIsSearching(false);
  }
}, [tableData]);

const highlightMatch = (text = "", searchTerm = "") => {
  if (!searchTerm.trim()) return text;

  // Escape regex special characters
  const escaped = searchTerm.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");

  const regex = new RegExp(`(${escaped})`, "gi");

  const parts = text.split(regex);

  return parts.map((part, i) =>
    regex.test(part) ? (
      <span
        key={i}
      className="bg-[orange] rounded-[2px] px-[2px] py-0"
      >
        {part}
      </span>
    ) : (
      part
    )
  );
};

  const renderDynamicTable = (rows = [], title) => {
    if (!rows || rows.length === 0) {
      return<p className="mt-4">No data available for {title}</p>;
    }

const headers = Array.isArray(rows) && rows.length > 0 ? Object.keys(rows[0]) : [];

    return (
<div ref={previewTableRef} className="overflow-x-auto mt-8">
  <table
  className="rules-table min-w-full border-collapse table-auto whitespace-nowrap"
  >
    <thead>
      <tr>
        {headers.map((h) => (
          <th
            key={h}
          className="p-[14px] text-left w-[220px] whitespace-nowrap"
          >
            {h}
          </th>
        ))}
      </tr>
    </thead>
    <tbody>
      {rows.map((row, idx) => (
        <tr key={idx}>
          {headers.map((h) => (
            <td
              key={h}
            className="p-[11px] whitespace-nowrap overflow-hidden w-[220px] text-ellipsis align-middle"
              title={row[h]} 
            >
              {row[h]}
            </td>
          ))}
        </tr>
      ))}
    </tbody>
  </table>
</div>


    );
  };
    
  return (
    <>
      
<div className="overflow-x-auto">
  <div
  ref={tableContainerRef}
 className="overflow-x-auto scroll-smooth"
>  
<p className="text-[#FF03F3] font-bold">List of Failed Rules</p>
   <div className="flex items-center gap-3">
      <div className="relative w-[200px] mt-[6px] flex-shrink-0">
       <input
  type="text"
  className="text-[9px] placeholder-gray-400 py-2 pl-[10px] w-full outline-none border border-gray-500 rounded"
  placeholder="Search..."
  value={columnSearch.allsearch}
  onChange={(e) => {
    const value = e.target.value;
    setColumnSearch({ ...columnSearch, allsearch: value });
  }}
  onKeyDown={(e) => {
    if (e.key === "Enter") {
      setIsSearching(true);
      onSearchChange(columnSearch.allsearch);
    }
  }}
/>

  
        <Search
          size={14}
          color="#9CA3AF"
          className="absolute right-[8px] top-1/2 -translate-y-1/2 pointer-events-none"
        />
      </div>
  
      <button className="px-3 mt-[4px] py-1 text-gray-700 bg-white border border-gray-300 rounded"
      onClick={() => {
      const clearedFilters = {
          ruleId: "",
  ruleName: "",
  rulePhase: "",
  dqDimension: "",
  dataAssetName: "",
  failPercentageVsThreshold: "",
  breachDate: "",
  Status: "",
  ruleOwner: "",
  Ticket: "",
  allsearch: "", 
  
      };
  
      setColumnSearch(clearedFilters); 
        setIsSearching(true);     
      onSearchChange("");                  
      onColumnFiltersChange(clearedFilters); 
    }}>
        Reset
      </button>
  
   <div className="flex items-center gap-1 mt-[2px]">
    <ChevronLeft
    title="Scroll Left"
      className="cursor-pointer"
      onClick={() => {
        if (tableContainerRef.current) {
          tableContainerRef.current.scrollBy({ left: -200, behavior: "smooth" });
        }
      }}
    />
    <p className="text-[12px]">Scroll</p>
    <ChevronRight
      className="cursor-pointer"
      title="Scroll Right"
      onClick={() => {
        if (tableContainerRef.current) {
          tableContainerRef.current.scrollBy({ left: 200, behavior: "smooth" });
        }
      }}
    />
  </div>
  
    </div>
<table className="rules-tables mt-2">
<TableHead
  columnSearch={columnSearch}
  setColumnSearch={setColumnSearch}
  onColumnFiltersChange={onColumnFiltersChange}
  setIsSearching={setIsSearching}
/>
        <tbody>
  <TableBody
    isSearching={isSearching}
    tableData={tableData}
    columnSearch={columnSearch}
    highlightMatch={highlightMatch}
  />
</tbody>

      </table>
      </div>
      </div>

    {totalRecords > 0 && (
        <div className="pagination mt-4 flex items-center justify-between">
          <span>
            Showing {indexOfFirstRow} to {indexOfLastRow} of {totalRecords} entries
          </span>

          <div className="pagination-controls flex items-center gap-2">
            <button
              disabled={currentPage === 1}
              onClick={() => gotoPage(currentPage - 1)}
              className="px-3 py-1 border rounded disabled:opacity-50"
            >
              Previous
            </button>

{(() => {
  const pageButtons = [];
  const totalToShow = 5;

  let start = Math.max(1, currentPage - Math.floor(totalToShow / 2));
  let end = start + totalToShow - 1;

  if (end > totalPages) {
    end = totalPages;
    start = Math.max(1, end - totalToShow + 1);
  }

  if (start > 1) pageButtons.push(1);
  if (start > 2) pageButtons.push("...");

  for (let i = start; i <= end; i++) {
    pageButtons.push(i);
  }

  if (end < totalPages - 1) pageButtons.push("...");
  if (end < totalPages) pageButtons.push(totalPages);

  return pageButtons.map((p, idx) =>
    p === "..." ? (
      <span key={idx} className="px-2">...</span>
    ) : (
      <button
        key={idx}
        onClick={() => gotoPage(p)}
        className={`px-3 py-1 border rounded ${
          currentPage === p ? "bg-blue-500 text-white" : ""
        }`}
      >
        {p}
      </button>
    )
  );
})()}

            <button
              disabled={currentPage === totalPages}
              onClick={() => gotoPage(currentPage + 1)}
              className="px-3 py-1 border rounded disabled:opacity-50"
            >
              Next
            </button>
          </div>
        </div>
      )}
      <div className="flex justify-between mt-12 items-center">

       <div className="flex justify-between mt-12 items-center">
        <div className="para">
          <p className="mt-[7px] text-[16px] text-[#3F3F3F] font-medium">
            Select the table you want to view:
          </p>
        </div>
        <div>
          <select
            className="selct-table"
            value={selectedPreview}
            onChange={(e) => setSelectedPreview(e.target.value)}
          >
            <option value="">Select Table</option>
            {Object.keys(errorPreviews || {}).map((key) => (
              <option key={key} value={key}>
                {key}
              </option>
            ))}
          </select>
        </div>
      </div>
   {selectedPreview &&
  Array.isArray(errorPreviews[selectedPreview]) &&
  errorPreviews[selectedPreview].length > 0 && (
    <div
      className="flex items-center justify-between mt-2"
    >

      {/* LEFT SIDE: Scroll Controls */}
      <div className="flex items-center gap-2 mr-[20px] mt-[16px]">
        <ChevronLeft
          title="Scroll Left"
          className="cursor-pointer"
          onClick={() => {
           if (previewTableRef.current) {
  previewTableRef.current.scrollBy({
    left: -200,
    behavior: "smooth",
  });
}

          }}
        />

        <p className="text-[12px]">Scroll</p>

        <ChevronRight
          className="cursor-pointer"
          title="Scroll Right"
          onClick={() => {
          if (previewTableRef.current) {
  previewTableRef.current.scrollBy({
    left: 200,
    behavior: "smooth",
  });
}

          }}
        />
      </div>

      <button
        onClick={() => downloadExcel(selectedPreview)}
        disabled={isDownloading}
      className={`
  px-[15px] py-[9px] 
  bg-[#80C6AD] text-white 
  border-0 mt-[14px] 
  rounded-[4px] cursor-pointer
  ${isDownloading ? "opacity-70" : "opacity-100"}
`}

      >
        {isDownloading ? "Downloading..." : "Download Table"}
      </button>
    </div>
)}

</div>

{selectedPreview && (
  Array.isArray(errorPreviews[selectedPreview])
    ? renderDynamicTable(errorPreviews[selectedPreview], selectedPreview)
    : <p className="mt-[7px] text-red-400 text-center">{errorPreviews[selectedPreview]?.message || "No data available"}</p>
)}    </>
  );
};

export default Table;
